<tr-booking-confirmation *ngIf="isLoaded"></tr-booking-confirmation>